<template>
  <div>
    <h2>Online-Entschuldigung:</h2>
    <h4>Nach Rückkehr Ihres Kindes in die Schule muss eine schriftliche Entschuldigung vorgelegt werden.</h4>

    <b-form
      @submit="onSubmit"
    >
      <b-form-group
        id="parent"
        label="*Name des Erziehungsberechtigten:"
        label-for="parent"
      >
        <b-form-input
          id="parent"
          v-model="form.parentName"
          required
          placeholder=""
        />
      </b-form-group>
      <b-form-group
        id="child"
        label="*Name des Kindes:"
        label-for="child"
      >
        <b-form-input
          id="child"
          v-model="form.childName"
          required
          placeholder=""
        />
      </b-form-group>
      <b-form-group
        id="input-group-3"
        label="*Klasse:"
        label-for="class"
      >
        <b-form-select
          id="class"
          v-model="form.classOneToFour"
          :options="classOneToFour"
          required
        />
        <b-form-select
          id="class"
          v-model="form.classAbc"
          :options="classAbc"
          required
        />
      </b-form-group>
      <label>*von:</label>
      <b-form-datepicker
        id="start"
        v-model="form.start"
        class="mb-2"
        locale="de"
      />
      <label>bis: (falls anders als von)</label>
      <b-form-datepicker
        id="end"
        v-model="form.end"
        class="mb-2"
        locale="de"
      />
      <b-form-group
        id="email"
        label="E-mail:"
        label-for="email"
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          placeholder=""
        />
      </b-form-group>
      <label label-for="notes">Entschuldigungsgrund in Stichworten:<br>(Bitte teilen Sie <b>keine</b> gesundheitsbezogenen Daten mit)</label>
      <b-form-textarea
        id="notes"
        v-model="form.text"
        placeholder=""
        rows="3"
        max-rows="6"
      />
      <b-form-checkbox
        id="state"
        v-model="form.status"
        required
        name="state"
        value="true"
        unchecked-value="false"
      >
        *Einwilligung und Angaben zum Datenschutz:<br>
        Ich habe die <a href="/Datenschutzerklärung.html">Datenschutzerklärung</a> zur Kenntnis genommen. Ich stimme einer elektronischen Speicherung und Verarbeitung meiner eingegebenen Daten zu.<br>
        Die Einwilligung kann jederzeit per E-Mail an <a :href="'mailto:' + config['REVOKE_EXCUSES_PERMISSION_EMAIL']">{{ config['REVOKE_EXCUSES_PERMISSION_EMAIL'] }}</a> widerrufen werden.<br>
        Die Daten werden ausschließlich zum Zweck der Information der Lehrerinnen und Lehrer der {{ config['TITLE'] }} gespeichert und innerhalb von einer Woche nach Eingang der Meldung gelöscht.
      </b-form-checkbox>
      <small>* Benötigte Angaben.<br></small>
      <b-button
        type="submit"
        variant="primary"
      >
        Abschicken
      </b-button>
    </b-form>
  </div>
</template>

<script>

import { BForm, BFormGroup, BFormDatepicker, BFormTextarea, BFormCheckbox } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Krankmeldung',
  components: {
    BForm, BFormGroup, BFormDatepicker, BFormTextarea, BFormCheckbox
  },
  data: () => {
    return {
      form: {
        parentName: '',
        childName: '',
        email: '',
        text: '',
        state: 'false',
        start: '',
        end: ''
      },
      classOneToFour: [{ text: '1. Klasse', value: '1. Klasse' }, '2. Klasse', '3. Klasse', '4. Klasse']
    }
  },
  computed: {
    ...mapGetters('config', [
      'getConfig'
    ]),
    config () {
      return this.getConfig
    },
    classAbc () {
      if (this.config.classAbc) {
        return JSON.parse(this.config.classAbc)
      }
      return []
    }
  },
  mounted () {
    this.fetchConfig()
    const year = new Date().getFullYear()
    const month = ('0' + (new Date().getMonth() + 1)).slice(-2)
    const day = ('0' + new Date().getDate()).slice(-2)
    this.form.start = year + '-' + month + '-' + day
  },
  methods: {
    ...mapActions([
      'createExcuse'
    ]),
    ...mapActions('config', [
      'fetchConfig'
    ]),
    onSubmit (evt) {
      evt.preventDefault()
      this.createExcuse(this.form)
    }
  }
}
</script>

<style scoped>

</style>
